import { Grid } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Text } from "sunrise-ui";
import {
  CHART_COLORS,
  customTooltip,
} from "../../../constants/reactChartConstants";
import NoDataScreen from "../../../utilities/NoDataScreen";

//-------bar chart data------------

const actualAvgDurationDataset = {
  label: "Actual Average Duration",
  data: [],
  backgroundColor: [CHART_COLORS.BLUE],
  hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE],
};

const standardDurationDataset = {
  label: "Standard Duration",
  data: [],
  backgroundColor: [CHART_COLORS.YELLOW],
  hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW],
};

const barChartData = {
  labels: [],
  datasets: [actualAvgDurationDataset, standardDurationDataset],
};

const lineData = {
  labels: [],
  datasets: [],
};

const pileCycleDataset = {
  label: "Hours",
  data: [],
  fill: false,
  borderColor: CHART_COLORS.BLUE,
  tension: 0.1,
  pointStyle: "circle",
  pointRadius: 5,
  pointHoverRadius: 8,
};

const activityWiseBarOptions = {
  plugins: {
    tooltip: customTooltip,
  },
  maintainAspectRatio: true,
  scales: {
    y: {
      title: { display: true, text: "Time (Hrs)", font: { weight: "bold" } },
    },
    x: { title: { display: true, text: "Steps", font: { weight: "bold" } } },
  },
};

const pileCycleLineOptions = {
  plugins: {
    tooltip: customTooltip,
  },
  maintainAspectRatio: true,
  scales: {
    y: {
      title: {
        display: true,
        text: "Pile Cycle (Hrs)",
        font: { weight: "bold" },
      },
      ticks: {},
      min: 0,
    },
    x: {
      title: { display: true, text: "Time (Months)", font: { weight: "bold" } },
    },
  },
};

const SingleRigReport = ({ machineData, stepDetails }: any) => {
  const [averageDurationData, setAverageDurationData] = useState([]);
  const [standardDurationData, setStandardDurationData] = useState([]);
  const [stepNames, setStepNames] = useState([]);

  const [pileCycleDates, setPileCycleDates] = useState([]);
  const [pileCycleHours, setPileCycleHours] = useState([]);

  const getActualDurations = useCallback(
    (array: any) => {
      if (machineData?.stepDuration) {
        Object.keys(machineData?.stepDuration).forEach(
          (key) =>
            (array[Number(key) - 1] =
              Math.round((machineData.stepDuration[key] * 100) / (60 * 60)) /
              100)
        );
      }
      setAverageDurationData(array);
    },
    [machineData]
  );

  const getPileCycleDurations = useCallback(() => {
    const labelArray = machineData?.pileCycle?.map((range: any) => range.month);
    const valueArray = machineData?.pileCycle?.map(
      (range: any) => Math.round((range.value * 100) / (60 * 60)) / 100
    );
    setPileCycleDates(labelArray);
    setPileCycleHours(valueArray);
  }, [machineData]);

  useEffect(() => {
    if (stepDetails) {
      const idealDuration = stepDetails.map((step: any) => step.value);
      setStandardDurationData(idealDuration);
      const emptyArray = Array(idealDuration.length).fill(0);
      getActualDurations(emptyArray);
      setStepNames(stepDetails.map((step: any) => step.stepName));
      getPileCycleDurations();
    }
  }, [stepDetails, machineData, getActualDurations, getPileCycleDurations]);

  return (
    <>
      {machineData ? (
        <Grid container xs={12} spacing={4}>
          <Grid item xs={6}>
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">{`${
                  machineData ? machineData.machine?.machineDetail : ""
                } Activity-Wise Average Duration`}</span>
              </Text>
            </Grid>
            <Bar
              data={{
                ...barChartData,
                labels: stepNames,
                datasets: [
                  { ...actualAvgDurationDataset, data: averageDurationData },
                  { ...standardDurationDataset, data: standardDurationData },
                ],
              }}
              options={activityWiseBarOptions}
            />
          </Grid>
          <Grid item xs={6}>
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">{`${
                  machineData ? machineData.machine?.machineDetail : ""
                } Pile Cycle (hrs)`}</span>
              </Text>
            </Grid>
            <Line
              data={{
                ...lineData,
                labels: pileCycleDates,
                datasets: [{ ...pileCycleDataset, data: pileCycleHours }],
              }}
              options={pileCycleLineOptions}
            />
          </Grid>
        </Grid>
      ) : (
        <NoDataScreen text={`There are no data available for Rig`} />
      )}
    </>
  );
};

export default SingleRigReport;
